<template>
  <div>
    <Teleport v-if="afetrTitleActionSpaceMounted" to="#page-title-action-space">
      <div class="d-flex justify-content-end">
        <BasicButton
          v-if="isBcpManager"
          label="編集"
          variant="secondary"
          outlined
          icon="pi pi-pencil"
          @click="goto({ name: 'UsersSystemAdminBcpEdit', params: { id: id } })"
        />
      </div>
    </Teleport>

    <Card>
      <template #content>
        <FormatShow v-if="format" :format="format" />
        <div class="d-flex flex-wrap justify-content-center my-5">
          <BasicButton
            label="戻る"
            variant="secondary"
            class="me-5"
            outlined
            icon="pi pi-times"
            @click="backto({ confirm: false })"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useRouterUtil, useFormats, useUser } from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { Show as FormatShow } from "/@/vue/components/Molecules/Format";
import Card from "primevue/card";

const afetrTitleActionSpaceMounted = inject("afetrTitleActionSpaceMounted");

const { id, backto, goto } = useRouterUtil();

const { isBcpManager } = useUser();

const { getFormat } = useFormats();
const { data: format } = getFormat(id);
</script>

<style scoped></style>
